



































































import Vue from "vue";
import { round } from "@/features/home/utils";
import { getTodayMonth } from "@/commons/utils/dateHandling";
import { getCurrencySign } from "@/commons/utils/currencySign";

export default Vue.extend({
  props: {
    title: { type: String, required: true },
    data: { type: Number, default: null },
    volatility: { type: Number, default: null },
    expectedData: { type: Number, default: null },
    loading: { type: Boolean, required: true },
  },

  methods: {
    getMonth(): string {
      return getTodayMonth();
    },
    isNoData(): boolean {
      return this.data === null;
    },
    isNoVolatility(): boolean {
      return this.volatility === null;
    },
    isNoexpectedData(): boolean {
      return this.expectedData === null;
    },
    roundNumber(value: number): number {
      return round(value);
    },
    getCurrencySign(): string {
      return getCurrencySign();
    },
  },
});
